import { LookupBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class IDTypeLookup extends LookupBase {

    public idTypeId: number = 0;

    public idTypeName: string = "";

    // Client only properties / methods
}
